import {PostDeliveryNoteRequest} from '@dms/api/warehouse';
import {VatRateOption} from '@dms/shared';

import {
  DeliveryNoteDocumentPreviewFormDefinition,
  DeliveryNoteItem,
} from '../types/DeliveryNoteDocumentPreviewFormDefinition';

/**
 * Keeps the invoice line order and the exact source prices. The invoice states prices with up to
 * eight decimals, so rounding to two here would commit amounts that differ from the document.
 */
export function mapStructuredInvoiceToDeliveryNoteRequest(
  formValues: DeliveryNoteDocumentPreviewFormDefinition,
  vatRates: VatRateOption[]
): PostDeliveryNoteRequest {
  return {
    supplierId: formValues.basicInformation.supplier,
    warehouseId: formValues.basicInformation.warehouse,
    deliveryNoteNumber: formValues.basicInformation.deliveryNoteNumber,
    invoiceNumber: formValues.basicInformation.invoiceNumber,
    authorizationProfileId: formValues.basicInformation.authorizationProfile,
    paymentType: formValues.basicInformation.paymentType,
    currency: formValues.basicInformation.currency,
    externalRef: {
      extractionId: formValues.extractionId,
    },
    item: formValues.listOfItems
      .filter((item: DeliveryNoteItem) => item.isActive)
      .map((item: DeliveryNoteItem) => ({
        order: item.sourceLineNumber,
        catalogNumber: item.number ?? '',
        name: item.name ?? '',
        vatType: item.vat ?? '',
        vatRate: Number(vatRates.find((vat) => vat.value === item.vat)?.rate) || 0,
        purchasePrice: item.unitPrice ?? 0,
        stockValue: item.totalPrice ?? 0,
        quantity: item.quantity ?? 0,
        manufacturerId: item.manufacturer ?? '',
        handlingUnit: item.unit ?? '',
      })),
  };
}
